export default {
  MONITOR_DEVICE: 1,
  DETECT_DEVICE: 2
};
